<template>
    <v-container>

        <v-btn v-if="hasTreatment"  color="primary" :to="{ name: 'study.definition.add', params: { id: selectedStudy.id } }">
            <v-icon>add</v-icon>
            Créer une temporalité
        </v-btn>

        <v-data-table
            class="my-4"
            :headers="headers"
            :items="selectedStudy.follow_up_definitions"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <td>{{ props.item.name }}</td>
                <td>{{
                        props.item.follow_up_score_definitions.length ? props.item.follow_up_score_definitions.map(item => item.score.name).join(', ') : ''
                    }}
                </td>
                <v-btn v-if="hasTreatment" flat
                       :to="{name: 'study.definition.edit', params: { id: selectedStudy.id, definition: props.item.id } }">
                    <v-icon>edit</v-icon>
                </v-btn>
            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>

    </v-container>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'

export default {
    name: "StudyDetails",
    data() {
        return {
            has_error: false,
            search: '',
            headers: [
                {text: 'Temporalité', align: 'left', value: 'name'},
                {text: 'Scores', align: 'left', value: ''},
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'position',
                //descending:true
            }
        }
    },
    components: {},
    computed: {
        hasTreatment() {
            return !this.selectedStudy.treatments.length
        },
        ...mapState('studies', {
            selectedStudy: state => state.selectedStudy
        }),

    }
}
</script>

<style scoped>

</style>
